import Decision from "slotworks/state-machine/decisions/decision";
import gameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import G288SpinRecord from "integration/spin-record";

export default class IsStackAddAndFreespins extends Decision {
    
    public evaluate() {
        const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        
        return (record && record.stackAddFeatureTriggered && record.freespinsTriggered) ? Exit.True : Exit.False;
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/decisions/is-stack-add-freespins.ts